import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CreditActionCostDto, MceApiService } from '../../core/mceapi.client.generated';
import { match } from '../../shared/functions/functional';
import { appOpt } from '../../core/mceapi.client.helpers';

@Component({
  selector: 'mce-account-credit-costs',
  imports: [MatButtonModule, MatDialogModule, MatIconModule],
  templateUrl: './credit-costs.component.html',
  styles: ``,
})
export class CreditCostsComponent implements OnInit {
  private readonly mceApiService = inject(MceApiService);

  protected readonly loading = signal(false);
  protected readonly loaded = signal(false);
  protected readonly error = signal<string | undefined>(undefined);
  protected readonly creditCosts = signal<CreditActionCostDto[]>([]);

  protected readonly viewState = computed(() => ({
    loading: this.loading(),
    loaded: this.loaded(),
    error: this.error(),
    creditCosts: this.creditCosts(),
  }));

  ngOnInit() {
    this.loadCreditCosts();
  }

  protected retryLoad() {
    if (!this.loading()) {
      this.loadCreditCosts();
    }
  }

  protected creditCostLabel = (creditCost: CreditActionCostDto) => 
      match(
        () => 'n/a',
        (x: number) => `${x} credits`
      )(appOpt(creditCost.cost?.credits));


  private loadCreditCosts() {
    this.loading.set(true);
    this.error.set(undefined);

    this.mceApiService.v1BillingCreditActions().subscribe({
      next: creditCosts => {
        this.creditCosts.set(creditCosts ?? []);
        this.loaded.set(true);
        this.loading.set(false);
      },
      error: () => {
        this.error.set('Credit costs could not be loaded.');
        this.loading.set(false);
      },
    });
  }
}
